import React from 'react';
import { FaChalkboardTeacher, FaProjectDiagram, FaBriefcase } from "react-icons/fa";
import ScrollableCards from '../prograse/prograse';

const images1 = "./Banner/people-avatar-8.png"
const images2 = "./Banner/picture-88.png"

const Abouth = () => {

  const vision = [
    { Number: "Mission", Title: "To develop IT skills in IT profession as per market demands. So every IT student have a job." },
    { Number: "Vision", Title: "To make top class computer science and IT skill development center in India." },
    { Number: "Quality", Title: "Always focus on practical knowledge and live project as per market and IT firm demands." },
  ];
  const features = [
    { id: 1, title: "Training By IT Professionals", icon: <FaChalkboardTeacher size={30} className="text-blue-700" /> },
    { id: 2, title: "Live Project Experience", icon: <FaProjectDiagram size={30} className="text-blue-700" /> },
    { id: 3, title: "100% Placement Assistant", icon: <FaBriefcase size={30} className="text-blue-700" /> },
  ];

  return (<>
    <section className='pt-20'>
      <div
        className="relative  w-full min-h-[300px] bg-fixed bg-cover bg-center flex items-center justify-center overflow-hidden"
        style={{ backgroundImage: "url('/Banner/banner-1.jpg')" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white pt-24 z-10">
          ABOUTH US
        </h2>

      </div>
    </section>
    <section className=" text-black py-16 shadow-lg">
      <div className="flex flex-col md:flex-row items-center  bg-white p-5 ">
        {/* Left Section: Image */}
        <div className="md:w-1/2 h-auto flex justify-center items-center">
          <img
            src={images1} // Replace with actual path
            alt="Megascale Logo"
            className="w-96 h-auto object-contain  rounded-lg"
          />
        </div>


        {/* Right Section: Content */}
        <div className="md:w-1/2 text-gray-600  md:mt-0">
          <h2 className='text-4xl mb-5 text-gray-600'>About Us ?</h2>
          <p className="text-gray-600 mb-4 leading-relaxed">
            Our main goal is to build a bridge between the skill require by IT firm and talent created by student.
          </p>
          <ul className="list-disc list-inside space-y-2">
           <li className='border-b'>
              Megascale provides Information Technology(IT) development services in several technologies namely PHP(Core), PHP Frameworks, .Net, Graphic Designing, Digital Marketing etc. Mobile Application Development for I-Phone (IOS) and Android.
            </li>
            <li>
              Megascale also provides training in Photo editing software, Film and video making software.
            </li>
            <li>
              Megascale is a Professional Web and Software Development Institute based in Surat India for last 3 years. Our Software Development Institute focuses on PHP(Core), PHP Frameworks, IOS, Android, Graphics.
            </li>
            <li>
              We mainly focus on IT students , freshers and beginners IT professionals who want to learn technologies and upgrade their Technical Knowledge. Additionally we provide part-time training for those students who engage in their study or doing jobs. It will help them how to deal with new technical era and IT firm expectations.
            </li>
            <li>
              After the software training process is completed, we will guide the students, how to design their resume creatively and we schedule their interview with software development companies.
            </li>
            <li>
              After the software training process is completed, we will guide the students, how to design their resume creatively and we schedule their interview with software development companies.
            </li>
            <li>
              It will more beneficial for companies those looking for employee without doing recruitment and candidates can increase their higher abilities in IT practical knowledge. For more details visit to our office and we will guide you for more information.
            </li>
            <li>
              <span className="font-semibold">Office Address:</span> 411-412, New Escon Plaza, Chhaprabhatha Road, Chhaprabhatha, Amroli, Surat, Gujarat, India.
            </li>
          </ul>
        </div>
      </div>
      <div className=" flex items-center justify-center text-center p-4">
        <div className="grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3  w-full ">
          {vision.map((vision, index) => (
            <div key={index} className="p-6 px-1 text-gray-600 space-y-2">
              <h2 className="text-3xl md:text-4xl font-bold drop-shadow-lg">{vision.Number}</h2>
              <p className="text-lg  font-semibold drop-shadow-lg">{vision.Title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    <section>

    </section>
    <section className="bg-gray-100 py-10">
      <div className="container mx-auto px-4">
        <h1 className="text-center text-3xl md:text-4xl text-blue-700 font-semibold mb-10">
          WITH MEGASCALE YOU CAN
        </h1>

        {/* Timeline Wrapper */}
        <div className="flex flex-col md:flex-row items-center justify-center w-full max-w-5xl mx-auto relative">
          {features.map((feature, index) => (
            <div key={feature.id} className="relative flex-1 text-center">
              {/* Line Connector (show between first and second, second and third) */}
              {index !== 0 && (
                <div className="absolute top-10 -left-1/2 w-full h-[2px] bg-gray-300 hidden md:block"></div>
              )}

              {/* Circle with Icon */}
              <div className="w-20 h-20 bg-white rounded-full border-2 border-gray-300 flex items-center justify-center mx-auto shadow-md relative z-10">
                {feature.icon}
              </div>

              {/* Title */}
              <p className="mt-4 text-gray-700 font-medium">{feature.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
    <section>
      <div className="flex flex-col md:flex-row items-center shadow-lg bg-white p-5 ">
        {/* Left Section: Image */}
        <div className="md:w-1/2 text-gray-600 pl-10  md:mt-0">

          <p className="text-gray-600 mb-4 text-4xl">
          Interface friendly learning at MEGASCALE
          </p>
          <p className="text-gray-600 mb-4 leading-relaxed">
          In Megascale IT Skill Development Center, we give live project training so they can get better chance to prove their skills. We are here to help them to choose their stream as per their area of interest. For training there are senior IT professionals to train students.
          </p>
          <ul className="list-disc list-inside space-y-4">
          <li className="border-b transition-all duration-300 ease-in-out hover:text-xl hover:scale-105">
            Training By IT Professionals
            </li>
          <li className="border-b transition-all duration-300 ease-in-out hover:text-xl hover:scale-105">
            Time Flexibility
            </li>
          <li className="border-b transition-all duration-300 ease-in-out hover:text-xl hover:scale-105">
            Live Project Eperience
            </li>
          <li className="border-b transition-all duration-300 ease-in-out hover:text-xl hover:scale-105">
            100% Placement Assistant
            </li>
          </ul>
        </div>
        {/* Right Section: Content */}
        <div className="md:w-1/2 h-96 flex justify-center items-center">
          <img
            src={images2}
            alt="Megascale Logo"
            className="w-96 h-auto object-contain  "
          />
        </div>
      </div>
    </section>
    <ScrollableCards />
  
  </>
  );
};

export default Abouth;
